<template>
    <div class="notification ddialog">
        <h1>Add a new band</h1>
        <b-field label="Name *"
                 :type="{'is-danger': errors.has('name')}"
                 :message="errors.first('name')">
            <b-input v-model="band.name" name="name" v-validate="'required'"></b-input>
        </b-field>
        <b-field label="Genre *"
                 :type="{'is-danger': errors.has('genre')}"
                 :message="errors.first('genre')">
            <b-input v-model="band.genres" name="genre" type="string" v-validate="'required'"></b-input>
        </b-field>
        <b-field label="Country *"
                 :type="{'is-danger': errors.has('country')}"
                 :message="errors.first('country')">
            <b-input v-model="band.country" name="country" type="string" v-validate="'required'"></b-input>
        </b-field>
        <b-field label="Website">
            <b-input v-model="band.website"></b-input>
        </b-field>
        <button class="button is-primary" @click="validateBeforeSubmit">Save</button>
    </div>
</template>

<script>

    const axios = require('axios');

    export default {
        name: "CreateBand",
        data() {
            return {
            }
        },
        props: ["band"],
        methods: {
            createBand: function () {
                axios
                    .post(this.$backend + '/api/bands', this.band)
                    .then(response => {
                            if (response.status == 200) {
                                this.$toast.open({
                                    message: 'Band saved',
                                    type: 'is-success'
                                })
                            } else {
                                this.$toast.open({
                                    message: 'Error while saving band',
                                    type: 'is-error'
                                })
                            }
                            this.$parent.close()
                        }
                    )
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.createBand()
                        return
                    }
                    this.$toast.open({
                        message: 'Form is not valid! Please check the fields.',
                        type: 'is-danger',
                        position: 'is-bottom'
                    })
                    return;

                });
            }
        }
    }
</script>

<style scoped>

    .ddialog{
        min-width: 400px;
    }

</style>
